import { colors, screen } from 'components/styles/variables';
import numeral from 'numeral';
import { useTranslation } from 'react-i18next';

export interface MonthlyPaymentProps {
  monthlyPayment: number;
}

export default function MonthlyPayment({ monthlyPayment }: MonthlyPaymentProps): JSX.Element {
  const { t } = useTranslation();
  const currency = numeral(monthlyPayment).format('$0,0');
  // JSX renders this as separates nodes, this on different lines, if we put this directly in JSX
  const text = `est. ${currency}/${t('commonlyUsed.monthAbrev')}`;

  return (
    <div className="monthly-payment">
      {text}
      <style jsx>{`
        .monthly-payment {
          text-align: right;
          color: ${colors.G3};
          letter-spacing: 0.2px;
          font-size: 14px;
          font-weight: 300;
          white-space: nowrap;
        }

        @media (min-width: ${screen.smMin}) {
          .monthly-payment {
            font-size: 16px;
          }
        }
      `}</style>
    </div>
  );
}
